export default __webpack_public_path__ + "media/zurb/img/playground/real-data-icon-7e9e7f0b9a1ef04a47aef387812c33f5.png";